import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  CustomAutoComplete,
  CustomInputField,
} from "../CommonComponents/CustomCompontes";
import { ClientAction } from "../../actions/client";
import { companyWiseEmp } from "../../actions/Companywiseclient";

import AndHead from "../../img/AndHead.jpg";
import AndBase from "../../img/AndBase.jpg";
import AndFoot from "../../img/AndFoot.jpg";
import LoadingComponent from "../CommonComponents/LoadingComponent";

const initialCustomProps = [
  {
    name: "title",
    label: "Title",
    placeholder: "Add Title",
    type: "text",
    isRequired: true,
  },
  {
    name: "body",
    label: "Body",
    placeholder: "Add Body",
    type: "text",
    isRequired: true,
  },
  {
    name: "url",
    label: "URL",
    placeholder: "Add URL",
    type: "text",
  },
  {
    name: "module",
    label: "Module",
    placeholder: "Select Module",
    type: "select",
    options: [],
  },
  {
    name: "imagesUrl",
    label: "Images",
    type: "image",
    // gridSpan: {
    //   xs: 4,
    // },
  },
];

const initialAdsFormData = {
  title: "",
  body: "",
  url: "",
  module: null,
  imagesUrl: "",
};

const tableHeaders = [
  { title: "S.No", key: "sno", isVisible: true },
  { title: "Title", key: "title", isVisible: true },
  { title: "Body", key: "body", isVisible: true },
  { title: "URL", key: "url", isVisible: true },
  { title: "Module", key: "module", isVisible: true },
  { title: "Images", key: "imagesUrl", isVisible: true },
  { title: "Action", key: "action", isVisible: true },
];

function InputComps({ propsData, formData, key, handleChange = () => {} }) {
  const renderInputs = () => {
    if (propsData?.type === "text") {
      return (
        <CustomInputField
          sx={{ width: "100%", margin: "0px !important" }}
          disabled={propsData?.disabled || false}
          variant="outlined"
          size="small"
          type="text"
          label={propsData?.label || ""}
          id={propsData?.name || ""}
          placeholder={propsData?.placeholder || ""}
          name={propsData?.name || ""}
          value={formData[propsData?.name || ""] || ""}
          onChange={(e) => handleChange(e, propsData?.type, propsData?.name)}
          required={propsData?.isRequired || false}
        />
      );
    } else if (propsData?.type === "select") {
      return (
        <CustomAutoComplete
          id={propsData?.name || ""}
          options={propsData?.options || []}
          disabled={propsData?.disabled || false}
          sx={{
            ".MuiInputBase-root": {
              borderRadius: "5px !important",
              borderLeft: propsData?.isRequired
                ? "2px solid red"
                : "2px solid transparent",
              margin: "0px !important",

              "& input": {
                marginBottom: "0px !important",
              },
            },
          }}
          value={formData[propsData?.name || ""] || ""}
          onChange={(e, newVal) =>
            handleChange(newVal, propsData?.type, propsData?.name)
          }
          getOptionLabel={(option) => {
            if (typeof option === "string") return option?.replaceAll("_", " ");
            if (option && option.name) return option.name;
            if (option && option.type) return option.type;
            if (option && option.value) return option.value;

            return "";
          }}
          isOptionEqualToValue={(option, value) =>
            option?.id === value?.id ||
            option?.value === value?.value ||
            option?.type === value?.type ||
            option?.name === value?.name
          }
          renderOption={(props, option, { index }) => (
            <li
              {...props}
              key={
                option?.id ||
                option?.value ||
                option?.name ||
                option?.type ||
                `option-${index}`
              }
            >
              {typeof option === "string"
                ? option?.replaceAll("_", " ")
                : option?.name || option?.value || option?.type || ""}
            </li>
          )}
          renderInput={(params) => (
            <CustomInputField
              {...params}
              placeholder={propsData?.placeholder || ""}
            />
          )}
        />
      );
    } else if (propsData?.type === "image" || propsData?.type === "file") {
      return (
        <Box sx={{ display: "flex", alignItems: "center", columnGap: 1 }}>
          {!Boolean(formData[propsData?.name || ""] || "") && (
            <CustomInputField
              inputProps={{ accept: "image/png, image/jpeg" }}
              type="file"
              sx={{ width: "100%", margin: "0px !important" }}
              className="form-control"
              id={propsData?.name || ""}
              placeholder={propsData?.placeholder || ""}
              name={propsData?.name || ""}
              // value={currVal}
              onChange={(e) =>
                handleChange(e, propsData?.type, propsData?.name)
              }
              // required={isRequired}
            />
          )}

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              columnGap: 0.5,
              overflowX: "auto",
              mt: 0.3,
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {(formData[propsData?.name || ""] || "") &&
              (formData[propsData?.name || ""] || "")
                ?.split(",")
                ?.map((val, imgIndex) => (
                  <Box
                    sx={{
                      minWidth: "68px",
                      maxWidth: "68px",
                      minHeight: "38.5px",
                      maxHeight: "38.5px",
                      borderRadius: 1,
                      position: "relative",
                      overflow: "hidden",
                      border: "1px solid #ccc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      backgroundColor: "black", // ⬅️ black strips behind image
                    }}
                    onClick={() => {
                      const imgUrl = val;
                      if (imgUrl) window.open(imgUrl, "_blank");
                    }}
                  >
                    <Tooltip title="Remove" arrow>
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChange(imgIndex, propsData?.type, "removeUrl");
                        }}
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          width: 16,
                          height: 16,
                          backgroundColor: "#e53935", // red
                          borderRadius: "3px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          zIndex: 1,
                        }}
                      >
                        <span
                          style={{
                            color: "white",
                            lineHeight: 1,
                          }}
                        >
                          <CloseIcon
                            sx={{ fontSize: "13.5px", fontWeight: 600 }}
                          />
                        </span>
                      </Box>
                    </Tooltip>
                    <img
                      src={val || ""}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain", // ⬅️ show full image, add strips
                      }}
                    />
                  </Box>
                ))}
          </Box>
        </Box>
      );
    } else {
      return "";
    }
  };

  return <React.Fragment>{renderInputs()}</React.Fragment>;
}

function validateRequiredFields(customProps, formData) {
  for (const prop of customProps) {
    if (prop.isRequired) {
      const value = formData[prop.name];

      const isMissing =
        typeof value === "string"
          ? value.trim() === ""
          : Array.isArray(value)
          ? value.length === 0
          : value === null || value === undefined;

      if (isMissing) {
        alert(`Please fill required field: ${prop.label || prop.name}`);
        return true;
      }
    }
  }
  return false;
}
const getNestedValue = (obj, key) => {
  if (!key) return undefined;

  return key.split(".").reduce((acc, part) => {
    if (acc && acc[part] !== undefined) {
      return acc[part];
    }

    return undefined;
  }, obj);
};

const PreviewModal = ({
  openModal,
  previewData,
  handleCloseModal = () => {},
}) => {
  return (
    <div>
      <Dialog
        //className='Dialogbox'

        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            borderRadius: "16px",
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#32577e",
            p: "8px 16px",
            fontSize: "1rem",
            color: "white",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography>Ad Preview</Typography>

            <IconButton aria-label="close" onClick={handleCloseModal}>
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              borderRadius: "7px",
              bgcolor: "#000000",
              padding: "4px 3px",
              mt: "5px",
            }}
          >
            <Box
              sx={{
                paddingY: "5px",
                bgcolor: "#ECECEC",
                borderRadius: "7px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: 350,
                  borderRadius: 2,
                  overflow: "hidden",
                }}
              >
                {AndHead && (
                  <img
                    src={AndHead}
                    alt="Header"
                    style={{ width: "100%", height: "auto", display: "block" }}
                  />
                )}
              </Box>

              <Box
                sx={{
                  width: 338,
                  height: 170,
                  borderRadius: 2,
                  overflow: "hidden",
                  backgroundImage: previewData?.imagesUrl
                    ? `linear-gradient(rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0.18)), url(${previewData?.imagesUrl})`
                    : "none",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "100%",
                    minHeight: "100%",
                    overflow: "hidden",
                    padding: "10px 15px",
                  }}
                >
                  <Typography
                    sx={{ color: "#fff", fontSize: "22px", fontWeight: 550 }}
                  >
                    {previewData?.title || ""}
                  </Typography>
                  <Box sx={{ display: "flex", flex: 1, mt: "2px" }}>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: "14.5px",
                        fontWeight: 500,
                      }}
                    >
                      {previewData?.body || ""}
                    </Typography>
                  </Box>

                  {previewData?.url && (
                    <Button
                      variant="contained"
                      sx={{
                        // --- Capsule shape & sizing ---
                        borderRadius: "999px",
                        // px: 2.1,
                        // py: 0.65,
                        width: "115px",
                        height: "34px",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "12.5px",
                        letterSpacing: "0.3px",

                        // --- Glassmorphism effect ---
                        background: "rgba(255, 255, 255, 0.15)",
                        backdropFilter: "blur(10px) saturate(180%)",
                        WebkitBackdropFilter: "blur(10px) saturate(180%)",
                        border: "1px solid rgba(255, 255, 255, 0.25)",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                        color: "#fff",

                        // --- Hover & transition ---
                        transition: "all 0.3s ease",
                        "&:hover": {
                          background: "rgba(255, 255, 255, 0.25)",
                          transform: "translateY(-2px)",
                          boxShadow: "0 6px 25px rgba(0, 0, 0, 0.25)",
                        },

                        // --- Active click feedback ---
                        "&:active": {
                          transform: "scale(0.97)",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.2)",
                        },
                      }}
                    >
                      Explore More
                    </Button>
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  width: 350,
                  borderRadius: 2,
                  overflow: "hidden",
                }}
              >
                {AndBase && (
                  <img
                    src={AndBase}
                    alt="Header"
                    style={{ width: "100%", height: "auto", display: "block" }}
                  />
                )}
                {AndFoot && (
                  <img
                    src={AndFoot}
                    alt="Header"
                    style={{ width: "100%", height: "auto", display: "block" }}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const CompanyAdsConfiguration = ({ companyId }) => {
  const [customProps, setCustomProps] = useState(initialCustomProps);
  const [formData, setFormData] = useState(initialAdsFormData);
  const [modulelist, setModulelist] = useState([]);
  const [allAdsList, setAllAdsList] = useState([]);
  const [selectedAdsToUpdate, setSelectedAdsToUpdate] = useState(null);
  const [openPreviewModalDefs, setOpenPreviewModalDefs] = useState({
    open: false,
    dataToPreview: null,
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChangePreviewModalDefs = (selectedData) => {
    setOpenPreviewModalDefs({
      open: selectedData?.id ? true : false,
      dataToPreview: selectedData?.id ? selectedData : null,
    });
  };

  console.log("ads formData : ", modulelist);

  const fetchGetAllModules = () => {
    const payload = {
      companyId: companyId,
    };
    companyWiseEmp.getAllModules(payload).then((response) => {
      console.log("fetchGetAllModules data: ", response);
      if (response !== null) {
        setModulelist(Array.isArray(response?.data) ? response?.data : []);

        if (response.responseCode === 404) {
          //   alert("No record found Status List!!");
        }
      }
    });
  };

  const fetchGetAllCompanyWiseAdsByCompanyId = () => {
    const payload = {
      companyId: companyId,
    };
    companyWiseEmp.getAllCompanyWiseAds(payload).then((response) => {
      console.log("fetchGetAllCompanyWiseAdsByCompanyId data: ", response);
      if (response !== null) {
        setAllAdsList(Array.isArray(response?.data) ? response?.data : []);

        if (response.responseCode === 404) {
          alert("No record found Status List!!");
        }
      }
    });
  };

  const handleChange = (e, type, name) => {
    if (type === "select") {
      setFormData((prev) => ({
        ...prev,
        [name]: e,
      }));
    } else if (type === "file" || type === "image") {
      if (name === "removeUrl") {
        setFormData((prev) => {
          const existing = prev["imagesUrl"] || "";
          const arr = existing.split(",").filter((i) => i.trim() !== "");
          arr.splice(e, 1);
          const updated = arr.join(",");

          return {
            ...prev,
            ["imagesUrl"]: updated,
          };
        });
      } else {
        if (e.target.files[0]) {
          const file = e.target.files?.[0];
          if (!file) return;

          const payload = new FormData();
          payload.append("file", file);
          setIsLoading(true);
          ClientAction.uploadFile(payload)
            .then((res) => {
              // alert(res?.responseDescription || res);

              if (res.responseCode === 200 && res.data) {
                setFormData((prev) => ({
                  ...prev,
                  [name]: prev[name] ? `${prev[name]},${res.data}` : res.data,
                }));
              }

              e.target.value = null;
            })
            .catch((err) => {
              console.error("Upload failed:", err);
            })
            .finally(() => {
              setIsLoading(false);

              e.target.value = null;
            });
        }
      }
    } else {
      const value =
        name === "phoneNo" ? e.target.value.replace(/\D/g, "") : e.target.value;

      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleClearChanges = () => {
    setSelectedAdsToUpdate(null);
    setFormData(initialAdsFormData);
  };

  const handleSubmit = async (removingItem) => {
    if (!removingItem && validateRequiredFields(customProps, formData)) {
      return;
    }

    if (removingItem) {
      const confirmDelete = window.confirm("Are you sure you want to Remove ?");
      if (!confirmDelete) return;
    }

    const cleanedFormData = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => {
        const shouldTrim = customProps.some((prop) => prop.name === key);
        return [
          key,
          shouldTrim && typeof value === "string" ? value.trim() : value,
        ];
      })
    );

    const localData = JSON.parse(localStorage.getItem("data")) || {};

    let finalPayload = {};
    const createPayload = {
      title: cleanedFormData?.title,
      body: cleanedFormData?.body,
      url: cleanedFormData?.url,
      moduleId: cleanedFormData?.module?.id,
      isActive: true,
      imagesUrl: cleanedFormData?.imagesUrl,
      companyId: companyId,
      createdBy: localData?.id,
    };

    const updatePayload = {
      ...cleanedFormData,
      updatedBy: localData?.id,
      moduleId: cleanedFormData?.module?.id,
    };

    const deletePayload = {
      ...removingItem,
      updatedBy: localData?.id,
      isActive: false,
    };

    finalPayload = selectedAdsToUpdate
      ? updatePayload
      : removingItem
      ? deletePayload
      : createPayload;

    companyWiseEmp.saveCompanyWiseAds(finalPayload).then((response) => {
      console.log("getMasterMenuByCompanyId data: ", response);
      if (response !== null) {
        if (response?.responseCode === 200) {
          alert(response?.responseDescription || "");
          setSelectedAdsToUpdate(null);
          setFormData(initialAdsFormData);
          fetchGetAllCompanyWiseAdsByCompanyId();
        } else if (response?.responseCode === 400) {
          alert(response?.responseDescription || "");
        } else {
          alert("Something Went Wrong");
        }
      }
    });
  };

  useEffect(() => {
    if (companyId) {
      fetchGetAllModules();
      fetchGetAllCompanyWiseAdsByCompanyId();
    }
  }, [companyId]);

  useEffect(() => {
    if (companyId && Boolean(modulelist?.length > 0)) {
      setCustomProps((prevProps) =>
        prevProps.map((prop) => {
          if (prop.name === "module") {
            return { ...prop, options: modulelist };
          }
          return prop;
        })
      );
    }
  }, [companyId, modulelist]);

  useEffect(() => {
    if (companyId && selectedAdsToUpdate) {
      setFormData({
        ...initialAdsFormData,
        ...selectedAdsToUpdate,
        module: selectedAdsToUpdate?.menuModule,
      });
    }
  }, [companyId, selectedAdsToUpdate]);

  return (
    <Accordion className="main_accoardian" defaultExpanded={true}>
      <AccordionSummary
        className="accordianHeader"
        expandIcon={
          <AddCircleIcon fontSize="large" style={{ color: "white" }} />
        }
        aria-controls="panel1a-content"
        style={{
          background: "rgb(10 166 141)",
          borderRadius: "10px 10px 0px 0px",
          overflow: "hidden",
        }}
      >
        <Grid>
          <h3
            style={{
              color: "#fff",
              marginLeft: "10px",
              padding: "10px 2px",
            }}
          >
            Ads Configuration:-
          </h3>
        </Grid>
      </AccordionSummary>

      <AccordionDetails className="accoardian_body">
        <PreviewModal
          openModal={openPreviewModalDefs?.open}
          previewData={openPreviewModalDefs?.dataToPreview}
          handleCloseModal={handleChangePreviewModalDefs}
        />
        <LoadingComponent isLoading={isLoading} />
        <Box
          sx={{
            minWidth: "100%",
            padding: "5px 10px",
            mt: 2.5,
          }}
        >
          <Grid container spacing={1.5}>
            {customProps?.map((item, index) => {
              return (
                <Grid
                  item
                  xs={item?.gridSpan?.xs || 2}
                  key={`contact-person-prop-${index}`}
                >
                  <InputComps
                    propsData={item}
                    formData={formData}
                    handleChange={handleChange}
                  />
                </Grid>
              );
            })}
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid
                style={{
                  placeItems: "center",
                  display: "flex",
                  gap: "10px",
                  justifyContent: "flex-end",
                  marginTop: "5px",
                }}
              >
                <div
                  className="field_box"
                  style={{
                    paddingBottom: "12px",
                  }}
                >
                  <div
                    className="field_box_btn1"
                    style={{
                      cursor: "pointer",
                      paddingLeft: "13px",
                      paddingRight: "13px",
                    }}
                    onClick={() => handleClearChanges()}
                  >
                    Cancel
                  </div>
                </div>
                <div
                  className="field_box"
                  style={{
                    paddingBottom: "12px",
                  }}
                >
                  <div
                    className="field_box_btn1"
                    style={{
                      cursor: "pointer",
                      paddingLeft: "13px",
                      paddingRight: "13px",
                    }}
                    onClick={() => handleSubmit()}
                  >
                    Save
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={1.5} sx={{ mt: "5px" }}>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="a dense table">
                <TableHead
                  style={{ color: "#fff", backgroundColor: "#32577e" }}
                >
                  {tableHeaders?.map((item, index) => {
                    return (
                      <TableCell
                        className="tabalecellStyle"
                        key={`ads-head-cell-${index}`}
                      >
                        {item?.title}
                      </TableCell>
                    );
                  })}
                </TableHead>
                <TableBody>
                  {allAdsList?.map((rowItem, rowIndex) => {
                    return (
                      <TableRow key={`body-row-${rowIndex}`}>
                        {tableHeaders?.map((header, cellIndex) => {
                          return (
                            <TableCell key={`body-cell-${cellIndex}`}>
                              {header.key === "sno" ? (
                                <Box
                                  flex
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span>{rowIndex + 1}</span>
                                </Box>
                              ) : header.key === "imagesUrl" ? (
                                <Box
                                  sx={{
                                    minWidth: "68px",
                                    maxWidth: "68px",
                                    minHeight: "38.5px",
                                    maxHeight: "38.5px",
                                    borderRadius: 1,
                                    position: "relative",
                                    overflow: "hidden",
                                    border: "1px solid #ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    backgroundColor: "black",
                                  }}
                                  onClick={() => {
                                    const imgUrl =
                                      getNestedValue(rowItem, header.key) || "";
                                    if (imgUrl) window.open(imgUrl, "_blank");
                                  }}
                                >
                                  <img
                                    src={
                                      getNestedValue(rowItem, header.key) || ""
                                    }
                                    alt="Preview"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                </Box>
                              ) : header.key === "module" ? (
                                <span>
                                  {getNestedValue(rowItem, "menuModule.name") ||
                                    "-"}
                                </span>
                              ) : header.key === "url" &&
                                Boolean(getNestedValue(rowItem, header.key)) ? (
                                <a
                                  href={getNestedValue(rowItem, header.key)}
                                  target="_blank"
                                >
                                  {getNestedValue(rowItem, header.key) || "-"}
                                </a>
                              ) : header.key === "action" ? (
                                <>
                                  {!selectedAdsToUpdate ? (
                                    <Tooltip
                                      arrow
                                      PopperProps={{
                                        modifiers: [
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [0, -12],
                                            },
                                          },
                                        ],
                                      }}
                                      title="Preview"
                                    >
                                      <IconButton
                                        onClick={() =>
                                          handleChangePreviewModalDefs(rowItem)
                                        }
                                      >
                                        <VisibilityIcon
                                          sx={{ color: "#088dcaff" }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                  {selectedAdsToUpdate &&
                                  selectedAdsToUpdate?.id === rowItem?.id ? (
                                    ""
                                  ) : (
                                    <Tooltip
                                      arrow
                                      PopperProps={{
                                        modifiers: [
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [0, -12],
                                            },
                                          },
                                        ],
                                      }}
                                      title="Edit"
                                    >
                                      <IconButton
                                        style={{ color: "green" }}
                                        onClick={() =>
                                          setSelectedAdsToUpdate(rowItem)
                                        }
                                      >
                                        <EditIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}

                                  {selectedAdsToUpdate &&
                                  selectedAdsToUpdate?.id === rowItem?.id ? (
                                    <Tooltip
                                      arrow
                                      PopperProps={{
                                        modifiers: [
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [0, -12],
                                            },
                                          },
                                        ],
                                      }}
                                      title="Close"
                                    >
                                      <IconButton
                                        style={{ color: "red" }}
                                        onClick={() => handleClearChanges()}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                  {!selectedAdsToUpdate ? (
                                    <Tooltip
                                      arrow
                                      PopperProps={{
                                        modifiers: [
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [0, -12],
                                            },
                                          },
                                        ],
                                      }}
                                      title="Remove"
                                    >
                                      <IconButton
                                        onClick={() => handleSubmit(rowItem)}
                                      >
                                        <DeleteIcon sx={{ color: "red" }} />
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                <span>
                                  {getNestedValue(rowItem, header.key) || "-"}
                                </span>
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default CompanyAdsConfiguration;
